<template>
  <aside class="sidebar" :class="{ open: isOpen }">
    <div class="sidebar-header">
      <img src="../../assets/logo.png" alt="El Shaday" class="sidebar-logo" />
      <div class="sidebar-titles">
        <span class="sidebar-title">Acamp Check-in</span>
        <span class="sidebar-subtitle" v-if="adminName">Olá, {{ adminName }}</span>
        <span v-if="role && role !== 'ROOT'" class="role-badge" :class="`role-${role.toLowerCase()}`">
          {{ roleBadgeLabel }}
        </span>
      </div>
    </div>

    <nav class="sidebar-nav">
      <router-link to="/" class="nav-item" exact-active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/></svg>
        <span>Dashboard</span>
      </router-link>
      <router-link to="/acampantes" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.39 3.39 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.39 3.39 0 0 0 15 11a3.5 3.5 0 0 0 0-7Z"/></svg>
        <span>Acampantes</span>
        <span class="nav-badge" v-if="counters.total > 0">{{ counters.total }}</span>
      </router-link>
      <router-link to="/check-in" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M9 16.17L4.83 12l-1.42 1.41L9 19L21 7l-1.41-1.41L9 16.17z"/></svg>
        <span>Check-in</span>
        <span class="nav-badge badge-pending" v-if="counters.pending > 0">{{ counters.pending }}</span>
      </router-link>
      <router-link to="/scanner" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-8 13c-2.76 0-5-2.24-5-5s2.24-5 5-5s5 2.24 5 5s-2.24 5-5 5z"/></svg>
        <span>Scanner</span>
      </router-link>
      <router-link to="/confirmed" class="nav-item" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="m10.6 16.6l7.05-7.05l-1.4-1.4l-5.65 5.65l-2.85-2.85l-1.4 1.4l4.25 4.25ZM12 22q-2.075 0-3.9-.788t-3.175-2.137q-1.35-1.35-2.137-3.175T2 12q0-2.075.788-3.9t2.137-3.175q1.35-1.35 3.175-2.137T12 2q2.075 0 3.9.788t3.175 2.137q1.35 1.35 2.138 3.175T22 12q0 2.075-.788 3.9t-2.137 3.175q-1.35 1.35-3.175 2.138T12 22Z"/></svg>
        <span>Confirmados</span>
        <span class="nav-badge badge-confirmed" v-if="counters.confirmed > 0">{{ counters.confirmed }}</span>
      </router-link>

      <router-link v-if="canManageAdmins" to="/usuarios" class="nav-item nav-item-root" active-class="active">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M16 17v2H2v-2s0-4 7-4s7 4 7 4m-3.5-9.5A3.5 3.5 0 1 0 9 11a3.5 3.5 0 0 0 3.5-3.5m3.44 5.5A5.32 5.32 0 0 1 18 17v2h4v-2s0-3.63-6.06-4M15 4a3.39 3.39 0 0 0-1.93.59a5 5 0 0 1 0 5.82A3.39 3.39 0 0 0 15 11a3.5 3.5 0 0 0 0-7Z"/></svg>
        <span>Usuários</span>
      </router-link>
    </nav>

    <button class="logout-btn" @click="$emit('logout')">
      <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24"><path fill="currentColor" d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5l-5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/></svg>
      <span>Sair</span>
    </button>
  </aside>
</template>

<script>
const ROLE_LABEL = { ROOT: 'Root', ADMIN: 'Admin', CHECKIN: 'Voluntário' }

export default {
  name: 'SidebarNav',
  props: {
    isOpen: { type: Boolean, default: false },
    adminName: { type: String, default: '' },
    counters: { type: Object, default: () => ({ total: 0, pending: 0, confirmed: 0 }) },
    isRoot: { type: Boolean, default: false },
    role: { type: String, default: null },
    canManageAdmins: { type: Boolean, default: false }
  },
  computed: {
    roleBadgeLabel() { return ROLE_LABEL[this.role] || this.role }
  },
  emits: ['logout']
}
</script>

<style scoped>
.sidebar {
  width: 250px;
  background: var(--color-bg-surface);
  box-shadow: var(--shadow-card);
  display: flex; flex-direction: column;
  position: fixed; top: 0; bottom: 0; left: 0; z-index: 50;
}
.sidebar-header {
  display: flex; align-items: center; gap: var(--spacing-md);
  padding: var(--spacing-base);
  border-bottom: 1px solid var(--color-bg-separator);
}
.sidebar-logo {
  width: 40px; height: 40px; border-radius: var(--radius-circle);
  object-fit: cover; flex-shrink: 0;
}
.sidebar-titles { display: flex; flex-direction: column; min-width: 0; }
.sidebar-title { font-size: var(--text-md); font-weight: 700; color: var(--color-text-primary); }
.sidebar-subtitle { font-size: var(--text-xs); color: var(--color-text-muted); }
.role-badge {
  display: inline-block;
  margin-top: 4px;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  width: fit-content;
}
.role-admin { background: rgba(51, 102, 204, 0.12); color: var(--color-accent); }
.role-checkin { background: var(--color-bg-hover); color: #5f6368; }

.sidebar-nav {
  flex: 1; display: flex; flex-direction: column;
  padding: var(--spacing-md) 0; gap: 2px;
}
.nav-item {
  display: flex; align-items: center; gap: var(--spacing-md);
  padding: 12px var(--spacing-base);
  color: var(--color-text-secondary); text-decoration: none;
  font-size: var(--text-sm); font-weight: 500;
  border-left: 3px solid transparent;
  transition: var(--transition-fast);
}
.nav-item:hover { background: var(--color-bg-hover); color: var(--color-text-primary); }
.nav-item.active {
  background: rgba(51, 102, 204, 0.08);
  color: var(--color-accent);
  border-left-color: var(--color-accent);
  font-weight: 600;
}
.nav-badge {
  margin-left: auto;
  background: var(--color-bg-separator);
  color: var(--color-text-muted);
  font-size: var(--text-xs); font-weight: 700;
  padding: 2px 8px; border-radius: 12px; min-width: 24px; text-align: center;
}
.nav-item.active .nav-badge {
  background: var(--color-accent); color: #fff;
}
.badge-pending { background: rgba(243, 156, 18, 0.15); color: var(--color-warning); }
.badge-confirmed { background: rgba(46, 204, 113, 0.15); color: var(--color-success); }

.nav-item-root {
  margin-top: var(--spacing-md);
  border-top: 1px solid var(--color-bg-separator);
  padding-top: 14px !important;
}

.logout-btn {
  display: flex; align-items: center; gap: var(--spacing-md);
  padding: 12px var(--spacing-base);
  margin: var(--spacing-md);
  background: transparent;
  color: var(--color-text-muted);
  border: 1px solid var(--color-bg-separator);
  border-radius: var(--radius-md);
  font-size: var(--text-sm); cursor: pointer;
  transition: var(--transition-fast);
}
.logout-btn:hover { background: var(--color-bg-hover); color: var(--color-danger); border-color: var(--color-danger); }

@media (max-width: 768px) {
  .sidebar {
    transform: translateX(-100%);
    transition: transform 0.25s ease-in-out;
  }
  .sidebar.open { transform: translateX(0); }
}
</style>
